export const MAX_DATE_VALUE = 99991231;
export const MAX_DATE = new Date(Date.UTC(9999, 11, 31));

function pad(num: number, size: number): string {
  let numStr = num.toString();
  while (numStr.length < size) numStr = '0' + numStr;
  return numStr;
}

export const parseDateToAPIFormat = (dateString: string): string => {
  if (!dateString) return "";
  if (new Date(dateString) >= MAX_DATE) return MAX_DATE_VALUE.toString();
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1, 2);
  const day = pad(date.getDate(), 2);
  return `${year}${month}${day}`;
}

export const convertTimestamp = (timestamp: number): string => {
  const dateOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'UTC'
  };
  return new Intl.DateTimeFormat('en-US', dateOptions).format(timestamp);
};

/**
 * Formats a date string into a specified format.
 * @param dateString - The date string to format.
 * @returns The formatted date string or an empty string if the date is invalid.
 */
export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return '';
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');
  
  return `${year}-${month}-${day} ${hour}:${minute}`;
}

export function convertToISOFormat(input: any): any {
  const year = input.$y;
  const month = input.$M; 
  const day = input.$D;
  const hours = input.$H;
  const minutes = input.$m;
  const seconds = input.$s;
  const milliseconds = input.$ms;

  // Create a date object using UTC values from the input
  const date = new Date(Date.UTC(year, month, day, hours, minutes, seconds, milliseconds));

  // Convert to ISO string in UTC (Z at the end denotes UTC time)
  const isoString = date.toISOString();

  // Remove milliseconds (optional) to get the exact format requested
  const isoWithoutMillis = isoString.slice(0, -5) + 'Z';

  console.log(isoWithoutMillis);
  return isoWithoutMillis;
}

//Takes as input an iso timestamp and returns a string in the format YYYY-MM-DD
export function formatToDate(isoTimestamp: string): string {
  if (!isoTimestamp) {
    return '';
  }
  const date = new Date(isoTimestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatToDateTime(isoTimestamp: string): string {
  if (!isoTimestamp) {
    return '';
  }
  const date = new Date(isoTimestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day} ${hour}:${minute}`;
}

export function convertToISO(date?: string, originalTime: string = "00:00:00Z"): string {
  if (!date) {
    return "";
  }
  // If already in ISO format
  if (date.includes('T') && (date.includes('Z') || /[+-]\d{2}:\d{2}/.test(date))) {
    return date;
  }
  return `${date}T${originalTime}`;
}

export function convertToISODateTime(dateTime: string): string {
  if (!dateTime) {
    return "";
  }
  const [date, time] = dateTime.split(' ');
  return `${date}T${time}Z`;
}


